import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import DividerIcon from '../components/DividerIcon'
import DownloadApp from '../components/DownloadApp'
import Octogonos from '../components/Octogonos'
import PreFooter from '../components/PreFooter'
import ServicesHeading from '../components/ServicesHeading'
import tick from '../resourses/tickbig.png'
import img1 from '../resourses/Nosotros-1.webp'
import img2 from '../resourses/Nosotros-2.webp'

const Nosotros = props => {
    React.useEffect(() => {
        window.scrollTo(0,0)
    })
    const titleOctogonos = <h3 className="gold">
        Contamos con <span className="px-2" 
        style={{backgroundColor: '#958434', borderRadius: "0 30px 0px 30px", color:"white"}}> 
        tecnología propia</span> que nos permite seguir cada entrega
</h3>
    return (
        <div>
           <ServicesHeading
                classToAdd="us" 
                subtitle={" La trayectoria nos avala"} 
                title={<>Llevamos +70 años <br/>acompañando al sector<br/> agroindustrial,
                con soluciones<br/> para cada etapa del proceso</>}
                bgImages={[img1, img2]}
                topPadding={180}
                revealOnScroll
                subtitleStyle={{backgroundColor: '#958434', borderRadius: '0 40px 0px 30px', color: 'white', padding: '90px'}}
            />
            <DividerIcon />
            <Container className="mt-md-5">
                <Row>
                    <Col className="text-center">
                        <h4 className="greenblue bold">
                            Respaldamos las operaciones, desde la recepción hasta la entrega, <br/>
                            asegurando trazabilidad, calidad y eficiencia en cada etapa
                        </h4>
                    </Col>
                </Row>
            </Container>
            <Octogonos title={titleOctogonos} />
            <Container className="mt-5 pt-3">
                <Row >
                    <Col md={12}>
                        <p style={{backgroundColor: '#958434', borderRadius: "0 30px 0px 30px", fontSize: props.width > 769  ? "26px" : "22px" , width:"fit-content"}} 
                        className=" white ml-4 mb-n1 px-5">Precisión Operativa</p>
                    </Col>
                    <div style={{backgroundColor: 'whitesmoke',width: '100%'}}>
                        <Col className="px-5 pt-5 pb-4 d-flex"  md={12}>
                                <img src={tick} style={{objectFit:"contain",width:"25px"}} alt=""/>
                                <p className=" ml-2 mt-1 mb-0 big2"> 
                                    Contamos con tecnología y un gran equipo presentes en cada 
                                    operación, de principio a fin.
                                </p>
                        </Col>
                    </div>
                </Row>
            </Container>
            <Container className="mt-5">
            
            </Container>
            <Container>
                {/* Video de YouTube */}
                <Row>
                    <Col className="d-flex justify-content-center">
                        <div className="youtube-container">
                            <iframe
                                src="https://www.youtube.com/embed/K6dRH7RYDsQ?si=48oXPPpXHvumlQvr"
                                title="YouTube video player"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </Col>
                </Row>
                <Row className="mb-5">
                    <Col className="d-flex justify-content-center">
                        <button onClick={() => window.open("https://www.instagram.com/gualtieriehijos/", '_blank')} 
                        style={{ border: "solid 1px #0E3C39", borderRadius: "0px", backgroundColor: "#0E3C39", fontSize: "1.2rem" }} 
                        className="btn btn-light btn-insta white  mt-5 px-5" > {">"} Conocé más en Instagram</button>
                    </Col>
                </Row>
            </Container>
               <PreFooter />
        </div>
    )
}

export default Nosotros
